import React, { Fragment, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const LanguagePickerFooter = () => {
  const [isActive, setIsActive] = useState(false);
  const channels = useSelector((state) => state.channels);
  const [websites, setWebsites] = useState([]);
  const toggleActive = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    const lists = channels.channelIsB2b ? ["B2B","B2C"] : ["B2C","B2B"];
    setWebsites(channels[`channels${lists[0]}`].concat(channels[`channels${lists[1]}`]));
  }, [channels]);

  return (
      <div className={`language-picker-footer ${isActive ? 'active' : ''}`}>
      <div className="language-picker-footer-container">
        {websites.length > 0 && (
          <div
            title={websites[0].name}
            className="language-picker-footer--current"
            key={`link${websites[0].name}`}
            onClick={() => toggleActive()}
          >
            {websites[0].channelType} {websites[0].name} - <span>{websites[0].currencyCode}</span>
            <i className={`fas fa-chevron-${!isActive?'down':'up'}`}></i>
          </div>
        )}
        {isActive && (
          <Fragment>
            {websites.length > 0 && (
              <div className="language-picker-footer__wrapper">
                {websites.map((data, index) => (
                  <a
                    href={data.url}
                    title={data.name}
                    className={`language-picker--link${
                      index === 0 ? ' is-current-website' : ''
                    }`}
                    key={`link${index}`}
                  >
                    {data.channelType} {data.englishName} - <span>{data.currencyCode}</span>
                    {false && <img src={data.imageToUrl} />}
                  </a>
                ))}
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default LanguagePickerFooter;
